import { useLanguage } from '../contexts/LanguageContext';

function Terminos() {
  const { t } = useLanguage();
  return (
    <section className="section section--legal">
      <div className="section-inner section-inner--narrow">
        <br />
        <br />
        <br />
        <h1 className="section-title">{t('terminos.title')}</h1>
        <p className="section-intro">{t('terminos.intro')}</p>

        <div className="legal-block">
          <h2>{t('terminos.s1Title')}</h2>
          <p>{t('terminos.s1Content')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('terminos.s2Title')}</h2>
          <p>{t('terminos.s2P1')}</p>
          <p>{t('terminos.s2P2')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('terminos.s3Title')}</h2>
          <p>{t('terminos.s3P1')}</p>
          <p>{t('terminos.s3P2')}</p>
          <ul>
            <li>{t('terminos.s3L1')}</li>
            <li>{t('terminos.s3L2')}</li>
            <li>{t('terminos.s3L3')}</li>
          </ul>
        </div>

        <div className="legal-block">
          <h2>{t('terminos.s4Title')}</h2>
          <p>{t('terminos.s4P1')}</p>
          <p>{t('terminos.s4P2')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('terminos.s5Title')}</h2>
          <p>{t('terminos.s5P1')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('terminos.s6Title')}</h2>
          <p>{t('terminos.s6P1')}</p>
          <p>{t('terminos.s6P2')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('terminos.s7Title')}</h2>
          <p>{t('terminos.s7P1')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('terminos.s8Title')}</h2>
          <p>{t('terminos.s8P1')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('terminos.s9Title')}</h2>
          <p>{t('terminos.s9P1')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('terminos.s10Title')}</h2>
          <p>{t('terminos.s10P1')}</p>
          <p className="legal-disclaimer">{t('terminos.disclaimer')}</p>
        </div>
      </div>
    </section>
  );
}

export default Terminos;
